import type { ApiEvent } from '@api/events';
import { composeEventAddress } from '../../utils/eventAddress';

type Translate = (key: string, fallbackOrParams?: string | Record<string, string | number>) => string;

export function formatEventAddress(event: ApiEvent, t: Translate): string {
  if (event.fulfilment_type === 'self_pickup') {
    return t('events_section.pickup_at_grain_kitchen');
  }

  return composeEventAddress(event);
}
